import Attention from "./images/f-img1.png";
import Study from "./images/f-img2 Large.png";
import Weekly from "./images/f-img3 Large.png";
import Concept from "./images/f-img4 Large.png";
import Special from "./images/f-img5.png";
import Topic from "./images/f-img6 Large.png";
const features = [
    {
        img:Study,
        title:"Printed Study Materials",
        description:"We strive hard for extensive coverage of all courses in the form of lectures, study material and tests to ensure that students cover everything."
    },
    {
        img:Weekly,
        title:"Weekly Test",
        description:"Our topic-wise tests, major-tests and rigourous feedback mechanism help the students to know their level of understanding."
    },
    {
        img:Concept,
        title:"Concept Clearing Sessions",
        description:"We conduct one-on-one concept clearing sessions for better understanding of students."
    },
    {
        img:Topic,
        title:"Topic Wise DPS",
        description:"Every student is provided with topic wise modules and DPP material for their practice."
    }
];

export default features;
